/** In-memory topic names for drawer header titles on /start/:slug. */

const bySlug = new Map();
const listeners = new Set();

export function setTopicNavEntry(slug, name) {
  const key = String(slug || '').trim().toLowerCase();
  const label = String(name || '').trim();
  if (!key || !label) return;
  if (bySlug.get(key) === label) return;
  bySlug.set(key, label);
  listeners.forEach((fn) => {
    try { fn(); } catch { /* ignore */ }
  });
}

export function getTopicNavName(slug) {
  const key = String(slug || '').trim().toLowerCase();
  return key ? (bySlug.get(key) || null) : null;
}

export function subscribeTopicNav(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function titleFromTopicSlug(slug) {
  const raw = String(slug || '').trim();
  if (!raw) return 'Topic';
  return raw.replace(/-/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase());
}
